import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import MessageItem from './message-item';
import classes from './styles.module.scss';

const MessagesList = (props) => {
    const { events, otherMembersLastReadMarker, direct } = props;

    return (
        <div className={clsx('flex column nowrap', classes.root)}>
            {events.map((event, index) => {
                const isMessageSequenceFirst = index === 0 || events[index - 1].getSender() !== event.getSender();
                const isMessageSequenceEnd = index === events.length - 1 || events[index + 1].getSender() !== event.getSender();

                return (
                    <MessageItem
                        key={event.getId()}
                        event={event}
                        direct={direct}
                        otherMembersLastReadMarker={otherMembersLastReadMarker}
                        isMessageSequenceFirst={isMessageSequenceFirst}
                        isMessageSequenceEnd={isMessageSequenceEnd}
                    />
                );
            })}
        </div>
    );
};

MessagesList.defaultProps = {
    otherMembersLastReadMarker: undefined,
};

MessagesList.propTypes = {
    events: PropTypes.arrayOf(PropTypes.object).isRequired,
    otherMembersLastReadMarker: PropTypes.oneOfType([PropTypes.object]),
    direct: PropTypes.bool.isRequired,
};

export default MessagesList;
